module.exports = __webpack_public_path__ + "img/bot-avatar.e822cd93.png";